module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "listing-page"
  }, [_c('section', {
    staticClass: "page-header"
  }, [_c('h1', [_vm._v("Browse Locations")]), _vm._v(" "), _c('div', {
    staticClass: "options"
  }, [_c('h4', [_vm._v("View Options")]), _vm._v(" "), _c('div', {
    staticClass: "photo-options"
  }, [_c('label', [_vm._v("Default Photo")]), _vm._v(" "), _c('div', {
    staticClass: "radio-list"
  }, [_c('p', {
    staticClass: "option",
    class: {
      selected: _vm.photoselection == "relevant"
    },
    on: {
      "click": function($event) {
        _vm.photoselection = "relevant"
      }
    }
  }, [_c('i'), _vm._v(" Most relevant")]), _vm._v(" "), _c('p', {
    staticClass: "option",
    class: {
      selected: _vm.photoselection == "default"
    },
    on: {
      "click": function($event) {
        _vm.photoselection = "default"
      }
    }
  }, [_c('i'), _vm._v(" Default")])])]), _vm._v(" "), _c('div', {
    staticClass: "grid-options"
  }, [_c('label', [_vm._v("Thumbnail Size")]), _vm._v(" "), _c('div', {
    staticClass: "toggle-switch",
    class: {
      switched: _vm.fullsizeview
    },
    on: {
      "click": _vm.toggleViewSize
    }
  }, [_c('div', {
    staticClass: "option",
    class: {
      highlighted: !_vm.fullsizeview
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("view_module")]), _c('span', [_vm._v(" Grid")])]), _vm._v(" "), _c('div', {
    staticClass: "option",
    class: {
      highlighted: _vm.fullsizeview
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("view_stream")]), _c('span', [_vm._v(" Full")])]), _vm._v(" "), _c('div', {
    staticClass: "highlight"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, _vm._l((_vm.tags), function(tag) {
    return _c('div', {
      staticClass: "tile"
    }, [_vm._v("\n          " + _vm._s(tag.name) + " "), _c('a', {
      staticClass: "close material-icons",
      on: {
        "click": function($event) {
          _vm.removeTag(tag)
        }
      }
    }, [_vm._v("cancel")])])
  })), _vm._v(" "), (_vm.tags.length) ? _c('h4', {
    staticClass: "location-count"
  }, [_vm._v(_vm._s(_vm.pls.length) + " Locations")]) : _c('h4', {
    staticClass: "location-count"
  }, [_vm._v("Showing featured locations")]), _vm._v(" "), _c('span', {
    staticClass: "clear"
  })]), _vm._v(" "), _c('section', {
    staticClass: "categories"
  }, [_c('ul', {
    staticClass: "tabs"
  }, _vm._l((_vm.filteredCategories), function(category) {
    return (category.name != 'Zip') ? _c('li', {
      class: {
        selected: _vm.tabShowing === category.name
      },
      on: {
        "click": function($event) {
          _vm.tabShowing !== category.name ? _vm.tabShowing = category.name : _vm.tabShowing = false
        }
      }
    }, [_vm._v(_vm._s(category.name))]) : _vm._e()
  })), _vm._v(" "), _vm._l((_vm.filteredCategories), function(category) {
    return (category.name == _vm.tabShowing) ? _c('div', {
      staticClass: "category"
    }, [_vm._l((category.tags), function(tag, index) {
      return [_c('transition', {
        attrs: {
          "name": "fade"
        }
      }, [_c('span', [(!tag.selected) ? _c('div', {
        staticClass: "tile"
      }, [_c('router-link', {
        attrs: {
          "to": '/browse/' + tag.slug,
          "event": ""
        },
        nativeOn: {
          "click": function($event) {
            $event.preventDefault();
            $event.stopPropagation();
            _vm.selectTag(tag)
          }
        }
      }, [_c('label', [_vm._v(_vm._s(tag.name) + " "), _c('span', {
        staticClass: "count"
      }, [_vm._v(_vm._s(tag.plcount))])])])], 1) : _vm._e(), _vm._v(_vm._s(' ') + "\n            "), (tag.selected) ? _c('div', {
        staticClass: "tile selected",
        on: {
          "click": function($event) {
            _vm.removeTag(tag)
          }
        }
      }, [_c('label', [_vm._v(_vm._s(tag.name))])]) : _vm._e(), _vm._v(_vm._s(' ') + "\n            ")])]), _vm._v(_vm._s(' ') + "\n        ")]
    }), _vm._v(" "), (!category.tags.length) ? _c('div', {
      staticClass: "tile no-tags"
    }, [_c('label', [_vm._v("No results")])]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "justifier"
    }), _vm._v(" "), _c('div', {
      staticClass: "justifier"
    }), _vm._v(" "), _c('div', {
      staticClass: "justifier"
    }), _vm._v(" "), _c('div', {
      staticClass: "justifier"
    }), _vm._v(" "), _c('div', {
      staticClass: "justifier"
    })], 2) : _vm._e()
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "pl-listing",
    class: {
      grid: !_vm.fullsizeview, full: _vm.fullsizeview
    }
  }, [_c('BackToTop'), _vm._v(" "), _vm._l((_vm.pls), function(PL, index) {
    return [_c('PLThumb', {
      key: PL.plno,
      attrs: {
        "PL": PL,
        "fullsizeview": _vm.fullsizeview,
        "tagids": _vm.tagids,
        "photofilter": _vm.photoselection,
        "showpullsheet": true,
        "lazy": true
      }
    }), _vm._v(_vm._s(' ') + "\n      ")]
  }), _vm._v(" "), _c('div', {
    staticClass: "justifier"
  }), _vm._v(" "), _c('div', {
    staticClass: "justifier"
  }), _vm._v(" "), _c('div', {
    staticClass: "justifier"
  }), _vm._v(" "), _c('div', {
    staticClass: "justifier"
  })], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-21453075","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Listing.vue
// module id = 182
// module chunks = 1